import { FunctionComponent } from 'react'
import IconClose from './IconClose'

type ModalHeaderProps = {
	onClose: () => void
}

const ModalHeader: FunctionComponent<ModalHeaderProps> = ({ children, onClose }) => (
	<div className="modal-header">
		<h1>{children}</h1>
		<IconClose onClick={onClose} />
	</div>
)

export default ModalHeader
